import React from 'react';
import { connect } from 'react-redux';
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,Label,FormGroup, Input,InputGroup, InputGroupAddon,Card, CardBlock
} from 'reactstrap';
import { TabContent, TabPane, Nav, NavItem, NavLink,   CardTitle, CardText, Row, Col } from 'reactstrap';
import classnames from 'classnames';

import Spinner from 'react-spinkit';

import swal from 'sweetalert2'
import ReactTable from "react-table";
import "react-table/react-table.css";

import IconSave from 'react-icons/lib/md/save';
import IconEdit from 'react-icons/lib/md/edit';

import * as actions from '../../actions/movimientocompra';

import Select from 'react-select';
import moment from 'moment';

import {api} from '../../actions/_request';

import ModalTablas from '../../components/catalogos/modal_tablas';
import Articulo from "../inventario/Modal";
const SubmitLoad = () => (
    <div className="p-2">
        <Spinner name="ball-clip-rotate-multiple" color="#b5271f" />
    </div>
);

const unidades = [
    'Pieza',
     'Docena',
     'Par',
     'Paquete',
     'Kilo',
     'Gramo',
     'Litro',
     'Caja',
     'Metro',
     'Pie',
     'Pulgada',
     'Servicio',
     'No Aplica',
     'Galon',    
];


class ProductoModal extends React.Component
{
    constructor(props)
    {
        super(props)

        this.state = {
            producto: {              
                nombre:'',
                codigo:'',
                inventario_id:0,
                cantidad:1,
                costo:0,
                descuento:0,
                impuesto1:0,
                impuesto2:0,
                ieps:0,
                tipo_cambio:0,              
            },
            busqueda:{},
            action: 'save',
            activeTab: '1',
            modal:false,
            no_existe:'0',

             /*modal para agrgar nuevos registros*/
            modal_registro:0,
            tittle_registro:'',

        };

        this.handleInputChange = this.handleInputChange.bind(this);      
        this.handleSubmit = this.handleSubmit.bind(this);      
        this.resetModal= this.resetModal.bind(this);            
        this.handleSelectChange= this.handleSelectChange.bind(this);
         this.cerrar= this.cerrar.bind(this); 

        this.toggle_modal= this.toggle_modal.bind(this);   
        this.retorno= this.retorno.bind(this);  
        this.ChangeCode= this.ChangeCode.bind(this);
        this.handleClose= this.handleClose.bind(this);
        this.toggle_modal_registro= this.toggle_modal_registro.bind(this);
                 
    }

     modal_open(){
       document.getElementById('body').className = " modal-open";
    }
    toggle_modal_registro(objeto,opcion=0,titulo=''){
      // console.log('opcion---->'+opcion);
      if(opcion==0||opcion=='[object Event]'){
        // console.log('se agrega un modal-open')
        setTimeout(this.modal_open, 1000);
         
         //if(this.state.tabla_modal==14)
        //  document.getElementById('body').className = "modal-open modal-open";

        this.setState({
            modal : false,
            modal_productos:false,
            modal_registro:this.state.tabla_modal,
            tittle_registro:titulo,
            titulo:"",
            tabla_modal:"",
            campo_modal:"",         
        })

      }else{
        console.log('nada')
        this.setState({
            modal : false,
            modal_productos:false,
            modal_registro:this.state.tabla_modal,
            tittle_registro:titulo,
            titulo:"",
            tabla_modal:"",
            campo_modal:"",         
        })

      }
    }
    cerrar(){
        document.getElementById('body').className = "modal-open modal-open";
        this.props.toggle();
    }

     handleClose (event) {
     
        let {producto} = this.state;
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
        
        let campo="";
        let tabla=""

        
         switch (name) {
            case "codigo":                  
                  campo = "inventario_id";
                  tabla="/inventario_codigo";
                  break;   
        }
        let self =this;
        if(value!=""){
            api().get(`${tabla}/${value}`)
            .then(function(response)
            {                  
                if(response.status === 200)
                { 
                    let vaciar=0;
                     if(Object.keys(response.data).length > 0){
                        
                        let  retorno=response.data;
                        self.retorno(retorno,campo,vaciar,value);
                       
                       
                     }  else{
                         vaciar=1
                         swal("Oops..", "No Existe el Codigo");
                          self.retorno(response.data,campo,vaciar,value);
                     }
                            
                   
                }

            });
        }else{
            self.retorno([],campo,1,value); 
        }
            

   }

    ChangeCode(event) {
        let {producto} = this.state;
        const target    = event.target;
        let value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
        if(target.type === 'checkbox'){
            value='0';
            if(target.checked)
                value='1';
        }
        if(name=="no_existe"){
         producto.nombre="";
         producto.codigo_proveedor="";
         producto.codigo ="No Existe";
         if(value=='0')
         producto.codigo ="";
         producto.inventario_id =0;
         producto.costo=0;
         producto.impuesto1 =0;
         producto.impuesto2=0;
         producto.ieps = 0;
         this.setState({
            busqueda:{},
            producto:producto,
            [name] : value
        });

        }else{
            this.setState({
            [name] : value
           });
        }
        
     
        
    }

    retorno(objeto,campo,vacio=0,valor=""){
       // console.log('renglon---->',objeto);
        let {producto} = this.state;
        let self =this;

        switch (campo) {
            case "inventario_id":
                  producto[campo] = objeto.value?objeto.value:objeto.id;
                  producto.nombre=objeto.label?objeto.label:objeto.nombre;
                  producto.codigo = objeto.codigo_interno;
                  producto.codigo_proveedor=objeto.codigo;
                  producto.costo=objeto.costo;
                  producto.impuesto1 = objeto.impuesto1||0;
                  producto.impuesto2=objeto.impuesto2||0;
                  producto.ieps = objeto.ieps_compra;
                  break;
        }  

       if(vacio==1){
        console.log('vaciar')
        producto.nombre="";
        producto.codigo_proveedor='';
        producto.codigo =valor;
        producto[campo] =0;
        producto.costo=0;
        producto.impuesto1 =0;
        producto.impuesto2=0;
        producto.ieps = 0;
       }


         self.setState({
            producto : producto,
            busqueda:objeto,           
            modal:false,         
        })

    
       


    }
    toggle_modal(index=0,catalogo="",campo=""){  

        this.setState({
            modal : !this.state.modal,
            titulo:catalogo,
            tabla_modal:index,
            campo_modal:campo,         
        })
    }   
    handleSelectChange(select, name) {

        
        const value = select === null ? null : select.value;
        this.setState({
            producto: {
                ...this.state.producto,
                [name]: value
            }
        });
    }

     

    componentDidMount()
    {
         
        let indice = this.props.id;
        let producto=this.props.renglon
        let self = this;

        console.log('props---->',this.props)
              
         if(indice == null)
        {            
            self.resetModal();
        }else{

            console.log('editar')

             api().get(`/inventario_codigo/${producto.codigo}`)
            .then(function(response)
            {                  
                if(response.status === 200)
                { 
                    let vaciar=0;
                     if(Object.keys(response.data).length > 0){
                        
                        let  retorno=response.data;
                        self.setState({
                            producto: producto,
                            busqueda:retorno,
                            action:'update',
                              });
                        
                       
                       
                     }  else{
                         self.setState({
                            producto: producto,
                            busqueda:{},
                            no_existe:"1",
                            action:'update',
                              });
                         
                          
                     }
                            
                   
                }

            });
            

        }
    }

   

    resetModal(){
        this.setState({
            producto: {              
                nombre:'',
                codigo:'',
                inventario_id:0,
                cantidad:1,
                costo:0,
                descuento:0,
                impuesto1:0,
                impuesto2:0,
                ieps:0,
                tipo_cambio:0,              
            },
            busqueda:{},
            action: 'save',
            no_existe:'0',
        });
        
    }

    



    handleInputChange(event) {
        let {producto} = this.state;
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;

        producto[name] = value;
     
        this.setState({
            producto : producto
        });
    }

    objeto_mayusculas(objeto){
         for (var key in objeto) {
                if (objeto.hasOwnProperty(key)) {
                    // var valor=String(objeto[key]).toUpperCase();                 
                    // console.log('valor---->',valor)
                     
                         objeto[key] = String(objeto[key]).toUpperCase() ;
                         if( String(objeto[key]).toUpperCase()==='NULL')
                            objeto[key] ='';
                     
                    // console.log(key + " = " + objeto[key]);
                }
              }
              return objeto;
    }

     trunc (sVal, nDec = 0) {
  // var s = x.toString()
  // var l = s.length
  // var decimalLength = s.indexOf('.') + 1
  // var numStr = s.substr(0, decimalLength + posiciones)
  // return Number(numStr)


    var n = parseFloat(sVal); 
    var s = "0.00"; 
    if (!isNaN(n)){ 
     n = Math.round(n * Math.pow(10, nDec)) / Math.pow(10, nDec); 
     s = String(n); 
     s += (s.indexOf(".") == -1? ".": "") + String(Math.pow(10, nDec)).substr(1); 
     s = s.substr(0, s.indexOf(".") + nDec + 1); 
    } 
    return s; 
}
   
   

    handleSubmit(evt)
    {
        evt.preventDefault();
        let {producto} = this.state;
        let action=this.state.action;
        
        let save=true;
        let dato="";
        let self = this;        
        
            let check = ['nombre','codigo', 'cantidad','costo','descuento','impuesto1','impuesto2','ieps','tipo_cambio'];

            for(let i in check) {

            let key = check[i];

            let value = ""+producto[key];
            dato=key;
            console.log('campo--->',key)
            console.log('valor--->',value)


            if(value == ''){
                console.log("vacio");
                save = false;
                break;
            }
            if(value == null){
                 console.log("null");
                save = false;
                break;
            }
                
            }
            if(save){

            if(producto.cantidad<=0){
                dato='Cantidad';
                save=false
            }  
            if(producto.costo<=0){
                dato='Costo';
                save=false
            } 

            }
                
             
           
              
        producto=this.objeto_mayusculas(producto);
     

        if(save){
            let cantidad =parseFloat(producto.cantidad);
            let costo =parseFloat(producto.costo);
            let porcentaje_descuento =parseFloat(producto.descuento);
            let porcentaje_impuesto1 =parseFloat(producto.impuesto1);
            let porcentaje_impuesto2 =parseFloat(producto.impuesto2);
            let ieps =parseFloat(producto.ieps);


            producto.costo_total=cantidad*costo;
            let costo_total=producto.costo_total;

            producto.cantidad_descuento=(porcentaje_descuento/100)*costo_total;
            let cantidad_descuento=producto.cantidad_descuento;

            producto.importe=costo_total - cantidad_descuento;
            let importe = producto.importe;

            let cantidad_ieps= (ieps/100)*costo;

            let descuento_ieps=(porcentaje_descuento/100)*cantidad_ieps;
            producto.ieps_total=(cantidad_ieps- descuento_ieps)*cantidad;
            let ieps_total=(cantidad_ieps- descuento_ieps)*cantidad;

            let subtotal=importe+ieps_total;

            producto.cantidad_impuesto1=(porcentaje_impuesto1/100)*subtotal;
            producto.cantidad_impuesto2=(porcentaje_impuesto2/100)*subtotal;

            producto.total=subtotal+producto.cantidad_impuesto1+producto.cantidad_impuesto2;


            producto.ieps_total=this.trunc(producto.ieps_total,2);
            producto.impuesto1=this.trunc(producto.impuesto1,2);
            producto.impuesto2=this.trunc(producto.impuesto2,2);
            producto.descuento=this.trunc(producto.descuento,2);
            producto.costo=this.trunc(producto.costo,2);
            producto.cantidad=this.trunc(producto.cantidad,2);
            producto.costo_total=this.trunc(producto.costo_total,2);
            producto.cantidad_descuento=this.trunc(producto.cantidad_descuento,2);
            producto.importe=this.trunc(producto.importe,2);
            producto.cantidad_impuesto1=this.trunc(producto.cantidad_impuesto1,2);
            producto.cantidad_impuesto2=this.trunc(producto.cantidad_impuesto2,2);
            producto.total=this.trunc(producto.total,2);


            self.props.alerta({
                mensaje:"Producto Guardado con Exito!",
                tipo:"success",
                creacion:moment().format('Y-MM-DD H:m:s'),
            });

           document.getElementById('body').className = "modal-open modal-open";
           this.props.retorno(producto,action);
           this.props.toggle();
           



            

        }else{
            // swal("Oops..", "Por favor Verificar el Campo de " +dato);
            swal({
                        title: 'Oops..',
                        text: "Por favor Verificar el Campo de " +dato,
                        type: 'error',
                        showCancelButton: false,
                        confirmButtonColor: '#3085d6',
                        // cancelButtonColor: '#d33',
                        confirmButtonText: 'Continue!'
                    }).then((result) => {
                                           
                           
                         
                           
                        
                    })
                    document.getElementById('body').className = "modal-open modal-open";
            

        }

        


        

      

    }

    render()
    {

        let {producto,busqueda}=this.state;
        let no_existe=this.state.no_existe === "0" ? true : false;
        console.log('producto--->',this.state.producto)
  
        
        return(

           <Modal isOpen={this.props.open} toggle={this.cerrar} className="default modal-lg modal-80 modal_cliente">
                <ModalHeader toggle={this.cerrar}>{this.props.title}</ModalHeader>
                <ModalBody>
                    <div className="row mt-3 form_cliente">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-2"> 
                                        <div className="form-group">
                                            <label className="-block">Codigo:</label>
                                            <Input
                                            placeholder=""
                                            type="text"
                                            name="codigo"
                                            value={producto.codigo}
                                            onChange={ this.handleInputChange}
                                            onBlur={this.handleClose}
                                            className="input_button"
                                            readOnly={!no_existe}
                                           
                                            />
                                            <Button onClick={ (button) => { this.toggle_modal(26,"Productos","inventario_id") } } disabled={!no_existe}>...</Button>
                                        </div>
                                    </div>
                                
                                <div className="col-md-7 ">
                                        <FormGroup>
                                            <Label>Nombre</Label>
                                            <Input
                                            placeholder=""
                                            type="text"
                                            name="nombre"
                                            value={producto.nombre}
                                            readOnly={no_existe}
                                            onChange={ this.handleInputChange}
                                            />
                                        </FormGroup>
                                </div>
                                <div className="col-md-2 pt-2">
                                    <div className="form-group mt-4">
                                    <label >
                                        <input type="checkbox"
                                        name="no_existe" 
                                        checked={this.state.no_existe === "0" ? false : true}
                                        onChange={this.ChangeCode} 
                                        />&nbsp;&nbsp; No Existe
                                    </label>
                                    </div>
                                </div>
                                </div>

                            </div>                       
                    </div>
                    <div className="row mt-3 form_cliente">       
                        <div className="col-md-4">
                            <div className="row mt-3 form_cliente">
                                <div className="col-md-6 ">
                                    <FormGroup>
                                        <Label>Cantidad</Label>
                                        <Input
                                        placeholder=""
                                        type="number"
                                        name="cantidad"
                                        value={producto.cantidad}
                                        onChange={ this.handleInputChange}
                                        />
                                    </FormGroup>
                                </div>
                           
                                <div className="col-md-6">
                                    <FormGroup>
                                        <Label>Costo</Label>
                                        <Input
                                        placeholder=""
                                        type="number"
                                        name="costo"
                                        value={producto.costo}
                                        onChange={ this.handleInputChange}
                                        />
                                    </FormGroup>
                                </div>
                            </div>
                            <div className="row form_cliente">
                                <div className="col-6">
                                    <div className="form-group">
                                        <label className>Descuento</label>
                                        <InputGroup>
                                            <input
                                                type="number" 
                                                className="form-control"
                                                name="descuento"
                                                value={(producto.descuento)}
                                                onChange={this.handleInputChange}
                                            />
                                            <InputGroupAddon>%</InputGroupAddon>
                                            
                                        </InputGroup>
                                    </div>
                                </div>
                            </div>
                            <div className="row form_cliente">
                                <div className="col-md-12 ">
                                    <FormGroup>
                                        <Label>Impuestos</Label>
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <div className="form-group">
                                        <InputGroup>
                                         <InputGroupAddon>1-</InputGroupAddon>
                                            <input
                                                type="number" 
                                                className="form-control"
                                                name="impuesto1"
                                                value={(producto.impuesto1)}
                                                onChange={this.handleInputChange}
                                            />
                                            <InputGroupAddon>%</InputGroupAddon>
                                            
                                        </InputGroup>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="form-group">
                                        <InputGroup>
                                         <InputGroupAddon>2-</InputGroupAddon>
                                            <input
                                                type="number" 
                                                className="form-control"
                                                name="impuesto2"
                                                value={(producto.impuesto2)}
                                                onChange={this.handleInputChange}
                                            />
                                            <InputGroupAddon>%</InputGroupAddon>
                                            
                                        </InputGroup>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-3 form_cliente">
                                <div className="col-md-6 ">
                                    <FormGroup>
                                        <Label>IEPS</Label>
                                        <Input
                                        placeholder=""
                                        type="number"
                                        name="ieps"
                                        value={producto.ieps}
                                        onChange={ this.handleInputChange}
                                        />
                                    </FormGroup>
                                </div>
                           
                                <div className="col-md-6">
                                    <FormGroup>
                                        <Label>T.C</Label>
                                        <Input
                                        placeholder=""
                                        type="number"
                                        name="tipo_cambio"
                                        value={producto.tipo_cambio}
                                        onChange={ this.handleInputChange}
                                        />
                                    </FormGroup>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="row mt-3">
                                <div className="col-6 text-left">
                                    <FormGroup>
                                        <h6><Label>Precio 1: </Label></h6>
                                    </FormGroup>
                                </div>
                                <div className="col-6 text-left">
                                    <FormGroup>
                                        <h6><Label>{busqueda.contado?"$"+busqueda.contado:"$0.00"}</Label></h6>
                                    </FormGroup>
                                </div>
                                <div className="col-6 text-left">
                                    <FormGroup>
                                        <h6><Label>Precio 2: </Label></h6>
                                    </FormGroup>
                                </div>
                                <div className="col-6 text-left">
                                    <FormGroup>
                                        <h6><Label>{busqueda.credito?"$"+busqueda.credito:"$0.00"}</Label></h6>
                                    </FormGroup>
                                </div>
                                <div className="col-6 text-left">
                                    <FormGroup>
                                        <h6><Label>Precio 3: </Label></h6>
                                    </FormGroup>
                                </div>
                                <div className="col-6 text-left">
                                    <FormGroup>
                                        <h6><Label>{busqueda.p3?"$"+busqueda.p3:"$0.00"}</Label></h6>
                                    </FormGroup>
                                </div>
                                <div className="col-6 text-left">
                                    <FormGroup>
                                        <h6><Label>Precio 4: </Label></h6>
                                    </FormGroup>
                                </div>
                                <div className="col-6 text-left">
                                    <FormGroup>
                                        <h6><Label>{busqueda.p4?"$"+busqueda.p4:"$0.00"}</Label></h6>
                                    </FormGroup>
                                </div>
                                <div className="col-6 text-left">
                                    <FormGroup>
                                        <h6><Label>Precio 5: </Label></h6>
                                    </FormGroup>
                                </div>
                                <div className="col-6 text-left">
                                    <FormGroup>
                                        <h6><Label>{busqueda.p5?"$"+busqueda.p5:"$0.00"}</Label></h6>
                                    </FormGroup>
                                </div>
                                <div className="col-6 text-left">
                                    <FormGroup>
                                        <h6><Label>Ult. Costo: </Label></h6>
                                    </FormGroup>
                                </div>
                                <div className="col-6 text-left">
                                    <FormGroup>
                                        <h6><Label>{busqueda.costo?"$"+busqueda.costo:"$0.00"}</Label></h6>
                                    </FormGroup>
                                </div>
                                <div className="col-6 text-left">
                                    <FormGroup>
                                        <h6><Label>Moneda Compra: </Label></h6>
                                    </FormGroup>
                                </div>
                                <div className="col-6 text-left">
                                    <FormGroup>
                                    { no_existe &&
                                         <h6><Label>{busqueda.moneda_compra=="1"?"Pesos":"Dolar"}</Label></h6>
                                    }
                                        
                                    </FormGroup>
                                </div>
                            </div>
                        </div>
                         <div className="col-md-3">
                            <div className="row mt-3">
                                <div className="col-6 text-left">
                                    <FormGroup>
                                        <h6><Label>Excistencia: </Label></h6>
                                    </FormGroup>
                                </div>
                                <div className="col-6 text-left">
                                    <FormGroup>
                                        <h6><Label>{busqueda.existencia?busqueda.existencia:"0.00"}</Label></h6>
                                    </FormGroup>
                                </div>
                                <div className="col-6 text-left">
                                    <FormGroup>
                                        <h6><Label>Unid/Compra: </Label></h6>
                                    </FormGroup>
                                </div>
                                <div className="col-6 text-left">
                                    <FormGroup>
                                        <h6><Label>{busqueda.unidad_compra!="0"?unidades[parseInt(busqueda.unidad_compra)-1]:""}</Label></h6>
                                    </FormGroup>
                                </div>
                                <div className="col-6 text-left">
                                    <FormGroup>
                                        <h6><Label>Und/venta: </Label></h6>
                                    </FormGroup>
                                </div>
                                <div className="col-6 text-left">
                                    <FormGroup>
                                         <h6><Label>{busqueda.unidad_venta!="0"?unidades[parseInt(busqueda.unidad_venta)-1]:""}</Label></h6>
                                    </FormGroup>
                                </div>
                                <div className="col-6 text-left">
                                    <FormGroup>
                                        <h6><Label>Factor E/S: </Label></h6>
                                    </FormGroup>
                                </div>
                                <div className="col-6 text-left">
                                    <FormGroup>
                                        <h6><Label>{busqueda.factor_es?busqueda.factor_es:"0.00"}</Label></h6>
                                    </FormGroup>
                                </div>
                                <div className="col-6 text-left">
                                    <FormGroup>
                                        <h6><Label>IEPS: </Label></h6>
                                    </FormGroup>
                                </div>
                                <div className="col-6 text-left">
                                    <FormGroup>
                                        <h6><Label>{busqueda.ieps_compra?"$"+busqueda.ieps_compra:"$0.00"}</Label></h6>
                                    </FormGroup>
                                </div>
                                <div className="col-6 text-left">
                                    <FormGroup>
                                        <h6><Label>Impuesto 1: </Label></h6>
                                    </FormGroup>
                                </div>
                                <div className="col-6 text-left">
                                    <FormGroup>
                                        <h6><Label>{busqueda.impuesto1?busqueda.impuesto1 +" %":"0.00 %"}</Label></h6>
                                    </FormGroup>
                                </div>
                                <div className="col-6 text-left">
                                    <FormGroup>
                                        <h6><Label>Impuesto 2: </Label></h6>
                                    </FormGroup>
                                </div>
                                <div className="col-6 text-left">
                                    <FormGroup>
                                        <h6><Label>{busqueda.impuesto2?busqueda.impuesto2+" %":"0.00 %"}</Label></h6>
                                    </FormGroup>
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    {
                        this.props.movimientocompra.saving ?
                        <SubmitLoad /> : 
                        <div>
                            <Button color="primary" type="submit"  onClick={this.handleSubmit} >
                                <IconSave />&nbsp;Guardar
                            </Button>{' '}
                            <Button color="secondary" onClick={this.cerrar}>
                                Cancel
                            </Button>
                        </div>
                    }
                </ModalFooter>
                
                 { this.state.modal&&
                <ModalTablas
                    open={this.state.modal}
                    toggle={this.toggle_modal}                  
                    titulo={this.state.titulo}
                    catalogo={this.state.tabla_modal}
                    retorno={this.retorno}
                    campo={this.state.campo_modal}
                     agregar={this.toggle_modal_registro}
                />
            }
              {
                   this.state.modal_registro==26&& 
                   <Articulo 
                 open={this.state.modal_registro>0?true:false} 
                 toggle={this.toggle_modal_registro} 
                 title={this.state.tittle_registro} 
                 prospectoid={null}
                />
                }
            </Modal>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
         movimientocompra : state.movimientocompra,
        notificciones:state.notificciones
    }
};

export default connect(mapStateToProps, actions)(ProductoModal)


// WEBPACK FOOTER //
// ./src/views/movimientoscompras/ProductosModal.js